import React, { useEffect } from "react";
import { CategoryInterface } from "src/store/community/categoriesSlice";
import { selectKindEntities, selectKindIds } from "src/store/community/kindsSlice";
import { useAppSelector } from "src/store/hooks";
import { filterOption } from "src/helpers/FormHelper";
import { EntityId } from "@reduxjs/toolkit";

import { Button, Form, Input, Select } from "antd";
import './_Form.scss';
import FileDropzone from "src/componets/FileDropzone";

interface propsInterface {
  params: CategoryInterface;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();
  const kinds = useAppSelector(selectKindEntities);
  const kindIds = useAppSelector(selectKindIds);

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const renderKindOption = (id: EntityId) => {
    const item = kinds[id];

    if (!item) {
      return null;
    }

    return <Select.Option key={id} value={id} title={item.name}>{item.name}</Select.Option>
  }

  const renderKinds = () => {
    if (kindIds.length === 0) {
      return null;
    }

    return (
      <Form.Item
        name='kind_id'
        label="Select a kind"
      >
        <Select
          allowClear
          showSearch
          filterOption={filterOption}
          placeholder='Select a kind'
        >
          {kinds && kindIds.map(renderKindOption)}
        </Select>
      </Form.Item>
    )
  }

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone name='thumbnail' label='Thumbnail' preview={params?.thumbnail_url} />
      </div>

      <Form.Item name='app_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <Form.Item name='target' noStyle>
        <Input type="hidden" />
      </Form.Item>

      {renderKinds()}

      <Form.Item name='name' label="Name">
        <Input placeholder='Name' />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
